import React from "react";

import ReactDOM from 'react-dom'

import {
    Box,
    Button,
    ButtonGroup,
    Tooltip,
    IconButton,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@mui/material";

import {
    DataGridPro,
    LicenseInfo,
    GridToolbar,
    ptBR,
    gridClasses,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    getGridStringOperators,
    getGridSingleSelectOperators
} from '@mui/x-data-grid-pro';
import { ptBR as corePtBR } from '@mui/material/locale';
import {
    createTheme,
    ThemeProvider,
    StyledEngineProvider
} from '@mui/material/styles';

import LoadingButton from '@mui/lab/LoadingButton';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ReadIcon from '@mui/icons-material/Visibility';
import CopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HelpIcon from '@mui/icons-material/Help';
import EmailIcon from "@mui/icons-material/Email"
import SettingsIcon from "@mui/icons-material/Settings"
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

import Loading from '../../Loading';
import useValidationError from '../../ErrorValidation';
import ConfirmationDialog from '../../Dialogs/Confirmation';
import Modal from './Modal';
import EmailTemplateDialog from "./EmailTemplateDialog"
import ConfirmDeletion from './ConfirmDeletion';
import EditEventDialog from "./EditEventDialog"

import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import 'animate.css/animate.min.css';

import useNotification from "../../Notification"

import api from '../../../api';
import { getSession } from "../../../auth";
import UserPermissions from "../../User/Permissions";
import "./styles.css";

import userPermissions from "../../User/Permissions"
import OwnerDialog from "./ownerDialog";

const userGroups = userPermissions()

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATAGRID_LICENSE_KEY);

const theme = createTheme({
    palette: {
        primary: { main: '#21446C' },
    },
}, ptBR, corePtBR);

const templateStatusTranslations = {
    "APPROVED" : "Aprovado",
    "PENDING"  : "Análise",
    "REJECTED" : "Reprovado"
}

const usageOptions = [
    { value: "Pessoal", label: "Pessoal" },
    { value: "Corporativo", label: "Corporativo" },
]

class Template extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            pageSize: 0,
            objTemplates: {},
            viewTemplate: {},
            dataTemplates: [],
            dataColumns: [],
            loading: false,
            enterpriseId: 0,
            showModal: false,
            readTemplate: false,
            copyTemplate: false,
            renderKey: 0,
            deleteTemplate: '',
            templateRow: null,
            showDelete: false,
            clientsFilter: { items: [] },
            event: null,
            confirmReplace: null,
            confirmDelete: null,
            templateType: "whatsapp",
            emailTemplates: [],
            emailDataColumns: [],
            editEmailTemplate: null,
            deleteEmailTemplate: null,
            showTemplatesInfo: false,
        };

        this.categories = {
            'MARKETING': 'Marketing',
            'UTILITY': 'Utilidades'
        };

        if (UserPermissions().isAdmin)
            this.categories.AUTHENTICATION = 'Autenticação'

        this.categories_translate = {
            'AUTO_REPLY': 'Resposta automática',
            'ACCOUNT_UPDATE': 'Atualização da conta',
            'PAYMENT_UPDATE': 'Atualização de pagamento',
            'PERSONAL_FINANCE_UPDATE': 'Atualização de finanças pessoais',
            'SHIPPING_UPDATE': 'Atualização de envio',
            'RESERVATION_UPDATE': 'Atualização de reserva',
            'ISSUE_RESOLUTION': 'Resolução de problemas',
            'APPOINTMENT_UPDATE': 'Atualização de compromisso',
            'TRANSPORTATION_UPDATE': 'Atualização de transporte',
            'TICKET_UPDATE': 'Atualização de ingresso',
            'ALERT_UPDATE': 'Atualização de alerta',
            'TRANSACTIONAL': 'Transacional',
            'MARKETING': 'Marketing',
            'AUTHENTICATION': 'Autenticação',
            'OTP': 'Senha de uso único',
            'UTILITY': 'Utilidades'
        };
    }

    calculateScreenHeight = () => {
        const screenHeight =
            window.screen.height > 1200 ? 14 :
                window.screen.height > 1100 ? 12 :
                    window.screen.height > 1000 ? 10 :
                        window.screen.height > 900 ? 8 :
                            window.screen.height > 800 ? 6 :
                                window.screen.height > 700 ? 4 : 2;

        return screenHeight;
    }

    errorValidation = async (res) => {
        const resp = await useValidationError(res.status, res.message);

        if (resp)
            this.setState({
                viewTemplate: {},
                showModal: false
            });

        return resp
    }

    getTemplates = (param=null, retries=6) => {
        this.setState({ loading: true });

        let url = `/api/enterprises/${this.state.enterpriseId}/templates/?insights=True`

        if (param)
            url += '&update=True'

        api.get(url, {timeout: 0}).then(async (res) => {
            if (Object.values(res.data).some(value => value === 'caching...')) {
                if (retries > 0) {
                    return new Promise((resolve) => 
                        setTimeout(() => resolve(this.getTemplates(null, retries-1)), 5000)
                    );
                } else {
                    this.setState({ showTemplatesInfo: true })
                    throw new Error('Failed [getTemplates] after 6 retries');
                }
            }
            let screenHeight = 0;
            let rows = [];
            let obj = {};

            if (res.status && res.status === 400 && res.data && res.data.accountcode) {
                await useValidationError(res.status, res.data.accountcode);

            } else if (res.status !== 200) {
                await useValidationError(res.status, null);

            } else {
                screenHeight = this.calculateScreenHeight();

                if (screenHeight > res.data.length) {
                    screenHeight = res.data.length;
                }

                let waba_templates = []
                let uniqueNames = []
                if (getSession().profile.enterprise.abstraction_layer) {
                    Object.keys(res.data).forEach((key) => {
                        let number_templates = res.data[key].waba_templates.filter(obj => {
                            if (! uniqueNames.includes(obj.name)) {
                                uniqueNames.push(obj.name)
                                return true
                            }
                            return false
                        }).map(obj => ({
                            ...obj,
                            number: key
                        }))
                        waba_templates = [
                            ...waba_templates, 
                            ...number_templates
                        ]
                    })
                } else { waba_templates = res.data.waba_templates }

                let templates = waba_templates.filter((template) => {
                    return (template.language == 'pt_BR' && !template.name.includes('sample_'))
                })

                if (templates && templates.length) {
                    templates.forEach((item, index) => {
                        rows.push({ ...item, id: index, actions: item.name });

                        obj[item.name] = item;
                    });
                }
            }

            this.setState({
                objTemplates: obj,
                dataTemplates: rows,
                pageSize: screenHeight,
                loading: false
            });
        }).catch((err) => {
            this.setState({ loading: false });
        });
    }

    deleteTemplate = (templateName, templateRow) => {
        this.setState({
            loading        : true,
            deleteTemplate : '',
            templateRow    : null,
            showDelete     : false
        });

        let url = `/api/enterprises/${this.state.enterpriseId}/templates/${templateName}/`
        if (getSession().profile.enterprise.abstraction_layer)
            url += `?number=${templateRow.number}`

        api.delete(url, {timeout: 30000})
            .then(async (res) => {
                if (res.status !== 200) 
                    await useValidationError(res.status, null);
                else
                    await this.getTemplates();
                this.setState({ loading: false });
            })
            .catch((err) => {
                console.error(err);
                this.setState({ loading: false });
            });
    }

    readTemplate = (template) => {
        this.setState({
            viewTemplate: template,
            readTemplate: true,
            copyTemplate: false,
            showModal: true,
            renderKey: Math.random()
        });
    }

    copyTemplate = (template) => {
        this.setState({
            viewTemplate: template,
            readTemplate: false,
            copyTemplate: true,
            showModal: true,
            renderKey: Math.random()
        });
    }

    addTemplate = () => {
        if (this.state.templateType === "whatsapp") {
            this.setState({
                viewTemplate: {},
                readTemplate: false,
                copyTemplate: false,
                showModal: true,
                renderKey: Math.random()
            });
        } else {
            this.setState({
                showEmailModal: true,
            })
        }
    }

    translate = async (text) => {
        const response = await api.post("api/google/translate/", { text: text })
        if (response.status === 200)
            return response.data.data.translations[0].translatedText
        return
    }

    mountColumns = () => {
        const filterOperators = getGridStringOperators().filter(
            (operator) => ['contains', 'equals',
                'startsWith', 'endsWith',
                'isEmpty', 'isNotEmpty'].includes(operator.value)
        )
        const selectOptions = getGridSingleSelectOperators().filter(
            (operator) => ["is"].includes(operator.value))

        const dataColumns = [
            { field: 'name', headerName: 'Nome', flex: 0.75, filterOperators: filterOperators },
            { field: 'events', headerName: 'Eventos', flex: .75, filterOperators: filterOperators, hide: true,
                renderCell: (params) => {
                    const events = params.row.events
                    if (!Array.isArray(events) || events.length === 0)
                        return
                    return (
                        <Box sx={{ display: "flex", gap: ".25rem" }}>
                            {events.map((event, index) => (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    {event.name}
                                    {userGroups.isSupervisor &&
                                        <IconButton sx={{ padding: ".25rem" }} onClick={() => this.setState({ event: event })}>
                                            <SettingsIcon sx={{ fontSize: "1.15rem" }} />
                                        </IconButton>
                                    }
                                </Box>
                            ))}
                        </Box>
                    )
                }
            },
            {
                 field: 'number', headerName: 'Número', flex: 0.5, filterOperators: filterOperators
            },
            {
                field: "usage",
                headerName: "Uso",
                flex: 0.5,
                hide: true,
                type: "singleSelect",
                valueOptions: usageOptions,
                valueGetter: (params) => { return params.row.owner ? "Pessoal" : "Corporativo" },
                filterOperators: selectOptions.map((operator) => ({
                    ...operator,
                    getApplyFilterFn: (filterItem) => {
                        if (!filterItem.value) return null
                        return ({ value }) => value === filterItem.value
                    },
                    InputComponent: operator.InputComponent,
                })),
                renderCell: (params) => (
                    <Box>
                        {params.row.owner ? "Pessoal" : "Corporativo"}
                    </Box>
                )
            },
            { field: 'owner', headerName: 'Dono', flex: 0.5, filterOperators: filterOperators,  hide: true,
                renderCell: (params) => (
                    params.row.owner ? <Box>{params.row.owner}</Box> : null
                )
            },
            {
                field: 'category', headerName: 'Categoria', flex: 0.4, filterOperators: filterOperators,
                valueGetter: (params) => {
                    return this.categories_translate[params.value]
                },
                renderCell: (params) => (
                    <Box>
                        {params.value}
                    </Box>
                )
            },
            {
                field: "status", headerName: "Status", flex: 0.4, type: "singleSelect",
                valueOptions: Object.entries(templateStatusTranslations).map(([value, label]) => ({ value, label })),
                valueFormatter: ({ value }) => templateStatusTranslations[value] || value,
                filterOperators: selectOptions.map((operator) => ({
                    ...operator,
                    getApplyFilterFn: (filterItem) => {
                        if (!filterItem.value) {
                            return null
                        }
                        return ({ value }) => value === filterItem.value;
                    },
                })),
                renderCell: (params) => {
                    const value = params.value
                    const label = templateStatusTranslations[value] || value
                    const rejectedReason = value.toUpperCase() === "REJECTED" ? params.row.rejected_reason : null
                    return (
                        <>
                            <Chip
                                label={label}
                                color={
                                    value.toUpperCase() === "APPROVED"
                                        ? "success"
                                        : value.toUpperCase() === "PENDING"
                                        ? "warning"
                                        : "error"
                                }
                                size="small"
                            />
                            {value.toUpperCase() === "REJECTED" && rejectedReason && (
                                <HelpIcon
                                    sx={{ marginLeft: ".5rem", color: "#0288d1", cursor: "pointer" }}
                                    onClick={async () => {
                                        useNotification(
                                            "Motivo da rejeição",
                                            await this.translate(rejectedReason) || "Translation failed",
                                            "info"
                                        )
                                    }}
                                />
                            )}
                        </>
                    )
                },
            },
            {
                field: 'components', headerName: 'Visualizar', flex: 2.5, filterOperators: filterOperators,
                valueGetter: (params) => {
                    const component = params.row.components
                    return (component[0] && component[0].type == 'BODY')
                        ? (component[0].text + '...')
                        : '[MIDIA] ' + component[1].text + '...'
                },
                renderCell: (params) => (
                    <Box className="column-components">
                        {params.value}
                    </Box>
                )
            },
            {
                field: "insights_delivered",
                headerName: "Entregues (30d)",
                flex: 0.6,
                type: "number",
                filterable: false,
                sortable: true,
                valueGetter: (params) => params.row.insights?.delivered ?? null,
                renderCell: (params) => (
                    params.value != null
                        ? params.value.toLocaleString("pt-BR")
                        : "0"
                ),
            },
            {
                field: "insights_read_rate",
                headerName: "Leitura",
                flex: 0.65,
                type: "number",
                filterable: false,
                sortable: true,
                valueGetter: (params) => params.row.insights?.read_rate ?? null,
                renderCell: (params) => (
                    params.value != null
                        ? `${params.value.toLocaleString("pt-BR", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })}%`
                        : "0"
                ),
            },
            {
                field: 'actions', headerName: 'Ações', flex: .65, filterable: false, sortable: false,
                renderCell: (params) => (
                    <Box className="column-actions">
                        {UserPermissions().isAdmin && <Tooltip title="Alterar dono" disableInteractive>
                            <ManageAccountsIcon
                                className="icon-action read-icon"
                                onClick={() => this.setState({ownerDialog: params.row})}
                            />
                        </Tooltip>}
                        <Tooltip title="Visualizar template" disableInteractive>
                            <ReadIcon
                                className="icon-action read-icon"
                                onClick={() => this.readTemplate(this.state.objTemplates[params.value])}
                            />
                        </Tooltip>
                        <Tooltip title="Copiar template" disableInteractive>
                            <CopyIcon
                                className="icon-action copy-icon"
                                onClick={() => this.copyTemplate(this.state.objTemplates[params.value])}
                            />
                        </Tooltip>
                        {(UserPermissions().isAdmin || UserPermissions().isSupervisor || params.row.owner_id === getSession().id) &&
                            <Tooltip title="Deletar template" disableInteractive>
                                <DeleteIcon
                                    className="icon-action delete-icon"
                                    onClick={() => this.setState({ deleteTemplate: params.value, templateRow: params.row, showDelete: true })}
                                />
                            </Tooltip>
                        }
                    </Box>
                )
            }
        ];

        const emailDataColumns = [
            { field: "name", headerName: "Nome", flex: 1, minWidth: 180 },
            { field: "subject", headerName: "Assunto", flex: 1.5, minWidth: 220 },
            { field: "total_sent", headerName: "Enviados", width: 120, type: "number" },
            {
                field: "total_open",
                headerName: "Leitura",
                width: 150,
                type: "number",
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    const sent = params.row.total_sent ?? 0;
                    const opened = params.row.total_opens ?? 0;

                    return sent > 0 ? (opened / sent) * 100 : 0;
                },
                renderCell: (params) =>
                    `${params.value.toLocaleString("pt-BR", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    })}%`,
            },
            {
                field: 'actions',
                headerName: 'Ações',
                sortable: false,
                filterable: false,
                width: 110,
                renderCell: (params) => (
                    <>
                        <Tooltip title="Editar template" disableInteractive>
                            <EditIcon
                                className="icon-action edit-icon"
                                onClick={() => this.setState({ editEmailTemplate: params.row })}
                            />
                        </Tooltip>

                        <Tooltip title="Deletar template" disableInteractive>
                            <DeleteIcon
                                className="icon-action delete-icon"
                                onClick={() => this.setState({ deleteEmailTemplate: params.row })}
                            />
                        </Tooltip>
                    </>
                ),
            }
        ]

        return { dataColumns, emailDataColumns };
    }

    refresh = async () => {
        const user = getSession();

        if (user)
            this.state.enterpriseId = user.profile.enterprise.id;

        const { dataColumns, emailDataColumns } = this.mountColumns();

        await this.setState({
            dataColumns: dataColumns,
            emailDataColumns: emailDataColumns,
        });
        
        await this.getTemplates();
    }

    componentWillMount() {
        this.refresh();
    }

    CustomToolbar = () => {
        return (
            <GridToolbarContainer className={gridClasses.toolbarContainer}>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <LoadingButton size="small"
                    component="label"
                    startIcon={<AddCircleIcon />}
                    onClick={() => this.addTemplate()}
                >
                    Adicionar
                </LoadingButton>
                {this.state.templateType !== "email" && userGroups.isSupervisor &&
                    <LoadingButton size="small"
                        component="label"
                        startIcon={<SettingsIcon />}
                        onClick={() => this.setState({ event: {} })}
                    >
                        Eventos
                    </LoadingButton>
                }
            </GridToolbarContainer>
        )
    }

    componentDidMount() {
        const actionContainer = document.getElementById("widgets-container")
        if (actionContainer) {
            const siblingContainer = document.createElement('div');
            siblingContainer.id = 'widgets-extra-actions';
            actionContainer.insertBefore(siblingContainer, actionContainer.firstChild);
            const siblingContent = (
                <>
                    <Tooltip title="Atualizar dados" disableInteractive>
                        <IconButton className="icon-refresh" onClick={() => this.getTemplates('update')}>
                            <RefreshIcon />
                        </IconButton>
                    </Tooltip>
                </>
            );
            ReactDOM.render(siblingContent, siblingContainer);
        }
    }

    componentWillUnmount() {
        const elementToRemove = document.getElementById('widgets-extra-actions');
        if (elementToRemove)
            elementToRemove.parentNode.removeChild(elementToRemove);
    }

    updateEvent = async (data, replace=false) => {
        const enterpriseId = getSession().profile.enterprise.id

        const formatOrNull = (time) => {
          return time && time.isValid && time.isValid() ? time.format("HH:mm") : null
        }

        const payload = { 
            ...data, 
            send_time: formatOrNull(data.send_time), 
            send_offset_time: formatOrNull(data.send_offset_time)
        }

        if (payload.message_parameters.headerfile) {
            const formData = new FormData()
            formData.append("file", payload.message_parameters.headerfile)
            const uploadResponse = await api.post(
                `api/enterprises/${enterpriseId}/message_events/upload/`,
                formData
            )
            if (uploadResponse.status === 201) {
                const domain = window.location.hostname
                payload.message_parameters.headerURL = `https://${domain}/api${uploadResponse.data.location}`
            }
            delete payload.message_parameters.headerfile
        }

        const response = (data.id)
            ? await api.patch(`api/enterprises/${enterpriseId}/message_events/${data.id}/`, payload)
            : await api.post(`api/enterprises/${enterpriseId}/message_events/?replace=${replace}`, payload)

        if ([200, 201].includes(response.status)) {
            this.getTemplates()
            this.setState({ confirmReplace: null })
            useNotification("Sucesso", "Evento atualizado com sucesso.", "success")
            return
        }

        if (response.status === 400 && "non_field_errors" in response.data && response.data["non_field_errors"][0] === "The fields enterprise, event must make a unique set.") {
            this.setState({ confirmReplace: data })
            return
        }
        
        useNotification("Ops", "Algo deu errado, tente novamente.", "danger")
    }

    deleteEvent = async (data) => {
        const enterpriseId = getSession().profile.enterprise.id
        const response = await api.delete(`api/enterprises/${enterpriseId}/message_events/${data.id}/`)
        if (response.status === 204) {
            this.getTemplates()
            this.setState({ confirmDelete: null })
            useNotification("Sucesso", "Evento excluído com sucesso.", "success")
            return
        }
        
        useNotification("Ops", "Algo deu errado, tente novamente.", "danger")
    }

    fetchEmailTemplates = async () => {
        try {
            this.setState({ loading: true })
            const enterpriseId = getSession().profile.enterprise.id
            const response = await api.get(`api/enterprises/${enterpriseId}/email_templates/`)
            if (response.status === 200) {
                this.setState({ emailTemplates: response.data })
            }
        } catch (err) {
            console.error(err)
            useNotification("Ops", "Algo deu errado, tente novamente.", "danger")
        } finally {
            this.setState({ loading: false })
        }
    }

    submitEmailTemplate = async (data) => {
        try {
            const enterpriseId = getSession().profile.enterprise.id
            const template = this.state.editEmailTemplate

            const response = template
                ? await api.patch(
                    `api/enterprises/${enterpriseId}/email_templates/${template.id}/`,
                    data
                )
                : await api.post(
                    `api/enterprises/${enterpriseId}/email_templates/`,
                    data
                )

            if (response.status === 200 || response.status === 201) {
                this.setState((prevState) => ({
                    emailTemplates: template
                        ? prevState.emailTemplates
                            .map((item) =>
                                item.id === response.data.id
                                    ? response.data
                                    : item
                            )
                            .sort((a, b) => a.name.localeCompare(b.name))
                        : [...prevState.emailTemplates, response.data]
                            .sort((a, b) => a.name.localeCompare(b.name)),
                    showEmailModal: false,
                    editEmailTemplate: null,
                }))

                useNotification(
                    "Sucesso",
                    template
                        ? "Template de e-mail atualizado com sucesso."
                        : "Template de e-mail criado com sucesso.",
                    "success"
                )

                return response.data
            }
        } catch (error) {
            console.error("Erro ao salvar template de e-mail:", error)

            if (error.response?.status === 400) {
                useNotification(
                    "Atenção!",
                    "Já existe um template de e-mail com esse nome.",
                    "warning"
                )
            } else {
                useNotification(
                    "Ops",
                    "Não foi possível salvar o template de e-mail. Tente novamente.",
                    "danger"
                )
            }

            throw error
        }
    }

    handleDeleteEmailTemplate = async () => {
        const template = this.state.deleteEmailTemplate

        if (!template) return

        this.setState({ deletingEmailTemplate: true })

        try {
            const enterpriseId = getSession().profile.enterprise.id

            await api.delete(
                `api/enterprises/${enterpriseId}/email_templates/${template.id}/`
            )

            this.setState((prevState) => ({
                emailTemplates: prevState.emailTemplates.filter(
                    (item) => item.id !== template.id
                ),
                deleteEmailTemplate: null,
            }))

            useNotification(
                "Sucesso",
                "Template de e-mail excluído com sucesso.",
                "success"
            )
        } catch (error) {
            console.error("Erro ao excluir template de e-mail:", error)

            useNotification(
                "Ops!",
                "Não foi possível excluir o template de e-mail. Tente novamente.",
                "danger"
            )
        } finally {
            this.setState({ deletingEmailTemplate: false })
        }
    }

    render() {
        return (
            <Box fullWidth className="templates-body">
                <Loading loading={this.state.loading} message="Sincronizando templates. Isto pode levar alguns segundos..."/>
                
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                    position="absolute"
                    right="16px"
                    top="127.5px"
                >
                    <ButtonGroup variant="outlined" aria-label="Tipo de template">
                        <Button
                            variant={
                                this.state.templateType !== "email"
                                    ? "contained"
                                    : "outlined"
                            }
                            startIcon={<WhatsAppIcon />}
                            onClick={() => {
                                if (this.state.templateType !== "whatsapp") {
                                    this.setState({ templateType: "whatsapp" })
                                }
                            }}
                        >
                            WhatsApp
                        </Button>

                        <Button
                            variant={
                                this.state.templateType === "email"
                                    ? "contained"
                                    : "outlined"
                            }
                            startIcon={<EmailIcon />}
                            onClick={() => {
                                if (this.state.templateType !== "email") {
                                    this.setState({ templateType: "email" })
                                    this.fetchEmailTemplates()
                                }
                            }}
                        >
                            E-mail
                        </Button>
                    </ButtonGroup>
                </Box>

                {/* <ReactNotifications /> */}
                <ConfirmDeletion
                    open={this.state.showDelete}
                    title={`Excluir ${this.state.deleteTemplate}`}
                    description={`Deseja realmente excluir o template ${this.state.deleteTemplate}?`}
                    handleClose={() => this.setState({ deleteTemplate: '', templateRow: null, showDelete: false })}
                    handleSubmit={() => this.deleteTemplate(this.state.deleteTemplate, this.state.templateRow)}
                />
                {(this.state.showEmailModal || this.state.editEmailTemplate) &&
                    <EmailTemplateDialog
                        open={true}
                        handleClose={() => this.setState({
                            showEmailModal: false,
                            editEmailTemplate: null,
                        })}
                        submit={this.submitEmailTemplate}
                        initialData={this.state.editEmailTemplate}
                    />
                }
                {this.state.deleteEmailTemplate && (
                    <ConfirmationDialog
                        open={this.state.deleteEmailTemplate}
                        title={"Excluir template de e-mail"}
                        description={
                            <>
                                Tem certeza de que deseja excluir o template{' '}
                                <strong>{this.state.deleteEmailTemplate.name}</strong>?
                                <br />
                                Essa ação não poderá ser desfeita.
                            </>
                        }
                        handleClose={() => this.setState({ deleteEmailTemplate: null })}
                        handleSubmit={this.handleDeleteEmailTemplate}
                    />
                )}
                <Modal
                    open={this.state.showModal}
                    handleClose={() => this.setState({ viewTemplate: {}, showModal: false })}
                    template={this.state.viewTemplate}
                    readTemplate={this.state.readTemplate}
                    copyTemplate={this.state.copyTemplate}
                    categories={this.categories}
                    getTemplates={() => this.getTemplates()}
                    errorValidation={async (res) => await this.errorValidation(res)}
                    key={this.state.renderKey}
                />
                <Box className="table-templates">
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={theme}>
                            {this.state.templateType === "whatsapp" &&
                                <DataGridPro
                                    pagination
                                    disableSelectionOnClick
                                    disableDensitySelector
                                    components={{ Toolbar: this.CustomToolbar }}
                                    density="compact"
                                    filterMode='client'
                                    columns={this.state.dataColumns}
                                    rows={this.state.dataTemplates}
                                />
                            }
                            {this.state.templateType === "email" &&
                                <DataGridPro
                                    pagination
                                    disableSelectionOnClick
                                    disableDensitySelector
                                    components={{ Toolbar: this.CustomToolbar }}
                                    density="compact"
                                    filterMode="client"
                                    columns={this.state.emailDataColumns}
                                    rows={this.state.emailTemplates}
                                />
                            }
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Box>
                {this.state.event !== null &&
                    <EditEventDialog event={this.state.event} templates={this.state.dataTemplates} close={() => this.setState({ event: null })} update={this.updateEvent} remove={(data) => this.setState({ confirmDelete: data })} />
                }
                {this.state.ownerDialog && <OwnerDialog 
                    handleClose={()=> this.setState({ownerDialog: null})}
                    data={this.state.ownerDialog}
                    reloadParent={this.getTemplates}
                />}
                {this.state.confirmReplace !== null &&
                    <ConfirmationDialog
                        open={this.state.confirmReplace}
                        title={'Confirmação'}
                        description={
                            <>
                                <Box>Já existe disparo automático configurado para <b>{this.state.confirmReplace.event_name}</b>.</Box>
                                <Box>Deseja substituí-lo?</Box>
                            </>
                        }
                        handleClose={() => this.setState({ confirmReplace: null })}
                        handleSubmit={() => this.updateEvent(this.state.confirmReplace, true)}
                    />
                }
                {this.state.confirmDelete !== null &&
                    <ConfirmationDialog
                        open={this.state.confirmDelete}
                        title={'Confirmação'}
                        description={<Box>Tem certeza que deseja excluir este disparo automático?</Box>}
                        handleClose={() => this.setState({ confirmDelete: null })}
                        handleSubmit={() => this.deleteEvent(this.state.confirmDelete)}
                    />
                }
                {this.state.showTemplatesInfo && (
                    <Dialog
                        open={this.state.showTemplatesInfo}
                        onClose={() => this.setState({ showTemplatesInfo: false })}
                    >
                        <DialogTitle>Aguarde alguns minutos</DialogTitle>

                        <DialogContent>
                            <DialogContentText>
                                As solicitações de templates estão demorando mais do que o
                                normal para serem processadas. Por favor, retorne em alguns
                                minutos para consultar o status.
                            </DialogContentText>
                        </DialogContent>

                        <DialogActions>
                            <Button
                                onClick={() => this.setState({ showTemplatesInfo: false })}
                                color="primary"
                            >
                                Entendi
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </Box>
        );
    }
}

export default Template;
